import Emitter from "es6-event-emitter";
import throttle from "lodash.throttle";

import regionSelector from "./../templates/region_selector.dust";
import regionList from "./../templates/regionList.dust";
import language from "./../../common/dictionary";

import {
  OPENED_REGIONSELECT,
  CLICKED_REGION_REGIONSELECT,
  CLICKED_PROCEED_REGIONSELECT,
} from "./../../common/analytics/analyticsevents";

import {
  getParameterByName,
  noop,
  removeURLParameter,
} from "./../utilities/utils";
import CookieManager from "../utilities/cookiemanager";

export default class RegionManager extends Emitter {
  //TODO: cleanup

  Regions = null;
  DOMContainer = null;
  // object containing Description and DownloadToken
  SelectedRegion = null;
  SelectedRegionName = "";
  getRegionPromiseResolve = null;
  getRegionPromiseReject = null;
  RegionCookie = "TW_REGION";
  _appState = null;
  _apiManager = null;
  _cookieManager = null;
  options = null;
  singleRegion = false;

  constructor(appState, apiManager, cookieManager, options) {
    super();
    // load the cookie (this is sync)
    this._apiManager = apiManager;
    this._appState = appState;
    this._cookieManager = cookieManager;
    this.options = options; //defaultRegion
    this.fetchRegion();
    this.setRegions();
  }

  getCurrentRegion() {
    return this.SelectedRegion;
  }

  setRegion(downloadToken) {
    const promise = new Promise((resolve) => {
      this.setRegions()
        .then(() => {
          var regionFound = false;
          for (let i = 0; i < this.Regions.length; i += 1) {
            if (this.Regions[i].Value === downloadToken) {
              this.SelectedRegion = this.Regions[i];
              this._appState.downloadToken = this.SelectedRegion.Value;
              regionFound = true;
              let downloadToken = getParameterByName("downloadToken");
              if (downloadToken) {
                window.location.href = removeURLParameter("downloadToken");
              }
              this.trigger("regionManager:regionChanged");
              break;
            }
          }
          // region is not found in region list (can be a HS for example)
          if (!regionFound) {
            if (this._appState.downloadToken != downloadToken) {
              this._appState.downloadToken = downloadToken;
              this.trigger("regionManager:regionChanged");
            }
          }
          resolve();
        })
        .catch(noop);
    });
    return promise;
  }

  getForceRegionCookie() {
    const fetchedString = this._cookieManager.getCookie(
      this.options.forceRegionCookie
    ); //TODO
    if (typeof fetchedString !== "undefined") {
      if (this.options.deleteForceRegionCookie) {
        this._cookieManager.removeCookie(
          this.options.forceRegionCookie,
          this.options.forceRegionCookieOptions
        );
      }
      try {
        const force = JSON.parse(fetchedString);
        if (force && force.token) {
          return force.token;
        }
      } catch (e) {
        return fetchedString;
      }
    }
    return null;
  }

  /**
   * Retrieves the region from search params
   * If the region is set inside the search param remove the params
   */
  getQueryRegion() {
    let downloadToken = getParameterByName("downloadToken");
    if (downloadToken) {
      return downloadToken;
    }
  }

  /**
   * Retrieves the region
   * If no region is selected yet or forceReloadOfRegion is true
   *        a view with a proceed button is rendered and the promise is only resolved if the button is pressed
   *
   * forceReloadOfRegion: force rendering and selectionscreen of region, even if there allready is a region
   * @type {[type]}
   */
  getRegion(DOMContainer, forceReloadOfRegion = false, regionClicked = false) {
    const regionSearchParam = this.getQueryRegion();
    this.DOMContainer = DOMContainer;
    this.getRegionPromise = new Promise((resolve, reject) => {
      this.getRegionPromiseReject = reject;
      this.getRegionPromiseResolve = resolve;
      this.setRegions().then(() => {
        if (!forceReloadOfRegion) {
          let region;
          if (this.options.defaultDownloadToken) {
            region = this.options.defaultDownloadToken;
          } else if (regionSearchParam) {
            region = regionSearchParam;
          } else {
            region = this.getForceRegionCookie();
          }
          if (region != null) {
            for (var i = 0; i < this.Regions.length; i++) {
              if (this.Regions[i].Value == region) {
                this.SelectedRegion = this.Regions[i];
                this.saveRegion(this.SelectedRegion);
                break;
              }
            }
          }
        }
        if (!forceReloadOfRegion && this.SelectedRegion != null) {
          this._appState.downloadToken = this.SelectedRegion.Value;
          this.getRegionPromiseResolve(this.SelectedRegion);
        } else {
          if (regionClicked) {
            this.populateRegionList(DOMContainer, true);
          } else {
            if (
              this.options.downloadToken &&
              this.options.downloadToken != ""
            ) {
              this._appState.downloadToken = "";
            } else {
              this.populateRegionList();
            }
          }
        }
      });
    });
    return this.getRegionPromise;
    // return a promise that will be resolved when
    // the onclick is done in onClickProceed or if region is
    // allready selected
  }

  /**
   * Renders a region selection screen in the DOMContainer
   * If renderOnlyList is true only the region list is rendered
   * @type {[type]}
   */
  render(
    DOMContainer = null,
    renderOnlyList = false,
    hideAfterSelection = true
  ) {
    if (DOMContainer) {
      this.DOMContainer = DOMContainer;
    }
    this.setRegions().then(() => {
      const context = {};
      context.Buttontext = language.Proceed;
      context.ChooseRegionTranslation = language.ChooseRegion;
      context.regions = this.Regions;
      if (this.options.defaultRegion === true) {
        context.defaultRegion = true;
      }
      if (this.DOMContainer !== null) {
        let dustFile = regionSelector;
        if (renderOnlyList) {
          dustFile = regionList;
        }
        Dust.render(dustFile, context, (err, result) => {
          this.DOMContainer.classList.remove("hidden");
          this.DOMContainer.innerHTML = result;

          this.setupListScrollButton();

          if (this.SelectedRegion) {
            for (let i = 0; i < this.Regions.length; i += 1) {
              if (
                this.Regions[i].Description === this.SelectedRegion.Description
              ) {
                $(this.DOMContainer)
                  .find(`.region_${i}_label`)
                  .trigger("click");
                const e = {};
                e.target = {};
                e.target.dataset = {};
                e.target.dataset.id = `region_${i}`;
                this.onRegionSelected(e, false);
                break;
              }
            }
          }
          // atach the click handlers for the selection and handle here
          if (!renderOnlyList) {
            $(this.DOMContainer)
              .find("#proceed-btn")
              .on("click", (e) => {
                this.onProceedTouch(e);
              });
          }
          $(this.DOMContainer)
            .find('input[name="region"]')
            .on("change", (e) => {
              if (renderOnlyList && hideAfterSelection) {
                this.DOMContainer.classList.add("hidden");
              }
              this.onRegionSelected(e, true);
            });
        });
      }
    });
    if (!renderOnlyList) {
      this._appState.triggerEvent(OPENED_REGIONSELECT);
    }
  }

  /**
   * Saves the selected region
   */
  saveSelectedRegion() {
    for (let i = 0; i < this.Regions.length; i += 1) {
      if (this.Regions[i].Description === this.SelectedRegionName) {
        this.SelectedRegion = this.Regions[i];
        this.saveRegion(this.SelectedRegion);
        break;
      }
    }
    this._appState.downloadToken = this.SelectedRegion.Value;
  }

  /**
   * When proceed button is clicked
   * resolve promise that is returned when getRegion was called
   */
  onProceedTouch() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.add("hidden");
    }
    this.getRegionPromiseResolve(this.SelectedRegion);
    this._appState.triggerEvent(CLICKED_PROCEED_REGIONSELECT);
  }

  /**
   * When a region is selected in the view
   * it saves the region and it triggers a regionChanged event
   */
  onRegionSelected(e, sendEvent) {
    $(this.DOMContainer).find("#proceed-btn").removeClass("is-disabled");
    const regionId = e.target.dataset.id;
    $(this.DOMContainer).find(".is-selected").removeClass("is-selected");
    $(this.DOMContainer)
      .find(`.${regionId}_label`)
      .removeClass("is-notselected")
      .addClass("is-selected");
    $(this.DOMContainer)
      .find("label:not(.is-selected)")
      .addClass("is-notselected");
    $(this.DOMContainer).find(`.${regionId}`);
    this.SelectedRegionName = $(this.DOMContainer).find(`.${regionId}`).val();

    if (sendEvent) {
      this.saveSelectedRegion();
      this.trigger("regionManager:regionChanged");
      this._appState.triggerEvent(CLICKED_REGION_REGIONSELECT);
    }
  }

  beautifyRegions() {
    const beautifyRegions = true;
    if (beautifyRegions) {
      //TODO: config?
      this.Regions.forEach((region) => {
        const regExp = /(^[0-9]+[_])/;
        if (regExp.test(region.Description)) {
          region.Description = region.Description.replace(regExp, "");
        }
      });
    }
  }

  setRegions() {
    const setRegionPromise = new Promise((resolve) => {
      if (this.Regions) {
        resolve(this.Regions);
      } else {
        this._apiManager.getRegions().then((json) => {
          this.Regions = json;
          this.beautifyRegions();
          this.validateSavedRegionInCookie();
          if (this.Regions.length === 1) {
            this.singleRegion = true;
          }
          resolve(this.Regions);
        });
      }
    });
    return setRegionPromise;
  }

  populateRegionList(DOMContainer = null, renderOnlyList = false) {
    this.setRegions().then(() => {
      if (this.Regions.length === 1) {
        this.setSelectedRegion(this.Regions[0]);
        this.getRegionPromiseResolve(this.SelectedRegion);
      } else {
        this.render(DOMContainer, renderOnlyList);
      }
    });
  }

  // validate if the saved region is still on the regions list
  validateSavedRegionInCookie() {
    let savedRegion = CookieManager.getCookie(CookieManager.cookieKeys.REGION);
    if (!savedRegion) return;

    savedRegion = JSON.parse(savedRegion);
    const regionInCurrentList = this.Regions.find((region) => {
      return region.Value === savedRegion.Value;
    });

    if (regionInCurrentList) return;
    CookieManager.removeCookie(CookieManager.cookieKeys.REGION);
    this.setSelectedRegion(this.Regions[0]);
  }

  setSelectedRegion(selectedRegion) {
    this.SelectedRegion = selectedRegion;
    this.saveRegion(selectedRegion);
    this._appState.downloadToken = selectedRegion.Value;
  }

  /**
   * saves a region in the cookie
   */
  saveRegion(region) {
    region.ContentPackages = [];
    this._cookieManager.createCookie(
      this._cookieManager.cookieKeys.REGION,
      JSON.stringify(region)
    );
  }

  /*
This fucntion will load the SelectedRegion out of the REGION cookie, we
use the cookie from the webapp v2 to make sure we are backward compatible.
It will do checking if the cookie content is correct.
   */
  fetchRegion() {
    const fetchedString = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.REGION
    );
    if (typeof fetchedString !== "undefined") {
      this.SelectedRegion = JSON.parse(fetchedString);
    } else {
      this.SelectedRegion = null;
    }
  }

  setupListScrollButton() {
    const listContainer = this.DOMContainer.querySelector(
      ".region-selector-items"
    );

    if (listContainer) {
      if (listContainer.scrollHeight > listContainer.offsetHeight) {
        this.scrollBtnEl = this.DOMContainer.querySelector(".scrolling-btn");
        this.scrollBtnEl.classList.remove("hidden");
        this.scrollBtnEl.addEventListener("click", this.onScrollBtnClick);
        listContainer.addEventListener("scroll", this.onListScroll);
      }
    }
  }

  onScrollBtnClick = () => {
    $(this.DOMContainer).animate(
      {
        scrollTop: this.DOMContainer.offsetHeight,
      },
      400
    );
    this.DOMContainer.scrollTop = this.DOMContainer.offsetHeight;
    const listContainer = this.DOMContainer.querySelector(
      ".region-selector-items"
    );

    if (listContainer) {
      $(listContainer).animate(
        {
          scrollTop: listContainer.offsetHeight,
        },
        400
      );
    }
  };

  onListScroll = throttle((e) => {
    if (
      e.currentTarget.scrollHeight - e.currentTarget.offsetHeight ===
      e.currentTarget.scrollTop
    ) {
      this.scrollBtnEl.classList.add("hidden");
      this.scrollBtnEl.classList.remove("animated");
    } else {
      this.scrollBtnEl.classList.remove("hidden");
    }
  }, 10);
}



// WEBPACK FOOTER //
// ./src/common/components/regionmanager.js